export default "__VITE_ASSET__dcl1Kr4O__ 600w";